var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.618,333.836c1.882-14.32,59.388-41.114,59.388-105.066c0-38.835,0-91.372,0-132.486 c0-59.388,35.41-100.501-130.192-95.937c-61.65,1.7-130.2,36.55-130.2,95.937c0,41.114,0,93.651,0,132.486 c0,63.952,57.506,90.746,59.388,105.066c5.712,43.4-138.19,34.263-143.902,178.164h214.714H460.52 C454.817,368.098,310.906,377.236,316.618,333.836z M245.815,203.644c0,0-52.537,18.274-68.525,11.415 c-15.988-6.851-29.699-45.686-13.71-86.792c0,0,34.262,6.852,82.236,6.852c47.964,0,82.227-6.852,82.227-6.852 c15.988,41.106,2.287,79.941-13.701,86.792C298.344,221.919,245.815,203.644,245.815,203.644z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.965,260.383c-11.234-8.411-24.482-9.509-29.69-2.559l-72.454,96.886 c13.066,6.538,28.741,14.486,44.126,25.448l68.847-92.05c1.42-1.873,2.104-4.201,2.104-6.718 C480.899,274.679,476.103,266.458,467.965,260.383z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinja);
export default __webpack_public_path__ + "static/media/ninja.71f2766f0d799b60cc987a8edb9f31c5.svg";
export { ForwardRef as ReactComponent };